export const TextSizeValues = {
  INTRO: 'intro',
  BODY_1: 'body-1',
  BODY_2: 'body-2',
  BODY_3: 'body-3',
  LEGAL: 'legal',
} as const;

export type TextSize = (typeof TextSizeValues)[keyof typeof TextSizeValues];

export const TextColorValues = {
  WEAK: 'weak',
  SIGNAL_ATTENTION: 'signal-attention',
  SIGNAL_NEGATIVE: 'signal-negative',
  SIGNAL_POSITIVE: 'signal-positive',
} as const;

export type TextColor = (typeof TextColorValues)[keyof typeof TextColorValues];
